import React from 'react';
import { AlertCircle } from 'lucide-react';
const BeforeYouBook = () => {
  return <div className="bg-amber-50 border-2 border-amber-300 rounded-lg p-6 mb-8" data-id="element-66" data-mp="3g3p7hcolg7ug">
      <div className="flex items-start mb-4" data-id="element-67" data-mp="3g5rvxsa3lsx2">
        <AlertCircle size={24} className="text-amber-600 mr-3 mt-1 flex-shrink-0" data-id="element-68" data-mp="31e18ii3vxl9w" />
        <h3 className="text-xl font-bold text-amber-900" data-id="element-69" data-mp="36cuk24zm327f">Before You Book</h3>
      </div>
      <ul className="space-y-3 text-gray-800" data-id="element-70" data-mp="2sdbbxc6svqv4">
        <li className="flex items-start" data-id="element-71" data-mp="2sgqtqmruze08">
          <span className="mr-2 text-amber-600 font-bold" data-id="element-72" data-mp="2wg7zlhb76d5x">•</span>
          <span data-id="element-73" data-mp="2ig6rphwim5gy">
            You must be able to drive independently and not require verbal or
            physical intervention from the instructor before your driving test.
          </span>
        </li>
        <li className="flex items-start" data-id="element-74" data-mp="gp3d6hji86r4">
          <span className="mr-2 text-amber-600 font-bold" data-id="element-75" data-mp="gq4zxj9vuhoo">•</span>
          <span data-id="element-76" data-mp="logci1rkb6al">
            We recommend passing a mock test at least one month before your DVSA
            test so we can fix anything that's left — otherwise the test may
            need to be rescheduled.
          </span>
        </li>
        <li className="flex items-start" data-id="element-77" data-mp="4pk94zcunhx3">
          <span className="mr-2 text-amber-600 font-bold" data-id="element-78" data-mp="ihgvemru6xlk">•</span>
          <span data-id="element-79" data-mp="igoztby8ozva">
            If you or anyone in your household is unwell, please cancel your
            lesson to avoid spreading illness.
          </span>
        </li>
        <li className="flex items-start" data-id="element-80" data-mp="3mwq4943yxn28">
          <span className="mr-2 text-amber-600 font-bold" data-id="element-81" data-mp="3mxsynm0i27mw">•</span>
          <span data-id="element-82" data-mp="3hxx1a5mb5egb">
            Pupils who arrive with cough/cold symptoms may be asked to end the
            lesson to protect other learners.
          </span>
        </li>
        <li className="flex items-start" data-id="element-83" data-mp="3qws6pfhj2kik">
          <span className="mr-2 text-amber-600 font-bold" data-id="element-84" data-mp="3qvyyea2x7myb">•</span>
          <span data-id="element-85" data-mp="1b5cpdjq0uben">
            Please maintain good personal hygiene so the car remains a pleasant,
            professional learning environment.
          </span>
        </li>
        <li className="flex items-start" data-id="element-86" data-mp="3twvmh47gftd">
          <span className="mr-2 text-amber-600 font-bold" data-id="element-87" data-mp="3svbzo94il01">•</span>
          <span data-id="element-88" data-mp="8s852qql8ob2">
            48 hours' notice is required for cancellations or rescheduling,
            regardless of whether payment was made in advance or on the day.
            Full details are in our{' '}
            <a href="/cancellation" className="text-burgundy-600 hover:text-burgundy-800 font-medium underline" data-id="element-89" data-mp="hto2zz07uxye">
              Cancellation, Health & Safety Policy
            </a>
            .
          </span>
        </li>
      </ul>
    </div>;
};
export default BeforeYouBook;